import { ChevronDown } from "lucide-react";

import { Reveal } from "@/components/site/Reveal";
import { faqs } from "@/lib/business";
import { slugify } from "@/lib/utils";

export function Faq() {
  return (
    <section
      id="faq"
      className="scroll-mt-28 border-b border-border py-20 sm:py-28"
      aria-labelledby="faq-heading"
    >
      <div className="mx-auto grid max-w-6xl gap-10 px-4 lg:grid-cols-[0.8fr_1.2fr]">
        <Reveal variant="left">
          <p className="eyebrow">FAQ</p>
          <h2 id="faq-heading" className="mt-3 text-4xl uppercase sm:text-5xl">
            Common questions
          </h2>
          <p className="mt-4 text-muted-foreground">
            Still have a question about your engine? Give us a call — we're happy to talk it
            through.
          </p>
        </Reveal>

        <ul className="grid gap-3">
          {faqs.map((faq, index) => (
            <Reveal key={faq.q} as="li" delay={index * 70}>
              <div id={slugify(faq.q)} className="surface-card scroll-mt-28 overflow-hidden">
                <details className="group">
                  <summary className="flex min-h-12 cursor-pointer list-none items-center justify-between gap-4 p-5 text-lg font-semibold">
                    {faq.q}
                    <ChevronDown
                      className="size-5 shrink-0 text-primary-text transition-transform duration-300 group-open:rotate-180"
                      aria-hidden="true"
                    />
                  </summary>
                  <p className="px-5 pb-5 text-sm leading-relaxed text-muted-foreground">{faq.a}</p>
                </details>
              </div>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
}
